import { Pipe, PipeTransform } from '@angular/core';
import { TipoSituacaoCadastral } from "../dominio/enums";

@Pipe({
  name: 'situacaoCadastral'
})
export class SituacaoCadastralPipe implements PipeTransform {

  transform(value: TipoSituacaoCadastral): string {
    switch (value) {
      case TipoSituacaoCadastral.Ativo:
        return 'Ativo';
      case TipoSituacaoCadastral.Inativo:
        return 'Inativo';
    };
  }

}
